export const ApiUrl = "https://sherwood.custom-ourbase.com/api";
export const baseUrl = "https://sherwood.custom-ourbase.com/";

// export const ApiUrl = "http://localhost:5000/api";
// export const baseUrl = "http://localhost:5000/";